module.exports = __webpack_public_path__ + "static/media/logo_hb_reversed.31823d0a.svg";